import { Box, Stack, Chip, Button } from '@mui/material';
import { useShow } from '@refinedev/core';
import { Show } from '@refinedev/mui';
import { genAttributeSlug } from 'shiver-core/lib';
import { ReadOnlyField } from '../../../components/fields/ReadOnlyField.tsx';
import { getAppBaseUrl } from '../../../helpers/appUrl.ts';
import { Timeline } from '../../../types/index.ts';
import { ReadOnlyMilestoneListField } from './MilestoneListField.tsx';

export const TimelineShow = () => {
  const {
    query: { data, isLoading },
  } = useShow<Timeline>({
    resource: 'contents/timelines',
    queryOptions: {
      select({ data }) {
        return {
          data: Timeline.parse(data),
        };
      },
    },
  });

  const record = data?.data;

  // プレビューURLの生成
  const previewUrl = record
    ? `${getAppBaseUrl()}/timeline/${genAttributeSlug(record.id)}`
    : undefined;

  return (
    <Show
      isLoading={isLoading}
      headerButtons={({ defaultButtons }) => (
        <>
          {previewUrl && (
            <Button
              variant="contained"
              color="primary"
              href={previewUrl}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ textDecoration: 'none' }}
            >
              プレビュー
            </Button>
          )}
          {defaultButtons}
        </>
      )}
    >
      <Stack spacing={2}>
        <ReadOnlyField name="name" label="タイトル" fullWidth>
          {record?.name}
        </ReadOnlyField>
        <ReadOnlyField label="概要" fullWidth>
          <Box dangerouslySetInnerHTML={{ __html: record?.description ?? '' }} />
        </ReadOnlyField>
        <ReadOnlyField label="分野" fullWidth>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {record?.sectors?.map((item, index) => (
              <Chip key={index} label={`${item.category.name}／${item.name}`} size="small" />
            ))}
          </Box>
        </ReadOnlyField>
        <ReadOnlyField label="トピック" fullWidth>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {record?.topics?.map((item, index) => (
              <Chip key={index} label={item.name} size="small" />
            ))}
          </Box>
        </ReadOnlyField>
        <ReadOnlyMilestoneListField value={record?.milestones ?? []} />
      </Stack>
    </Show>
  );
};
